import type { SVGProps } from 'react';

// Eigenes Icon-Set: 24er-Raster, Linienstärke 2, runde Enden, currentColor.
// Keine Emoji, nirgends.

const paths = {
  logo: <><path d="M4 12.5 9.5 18 20 6" /><path d="M14 18h6" /></>,
  search: <><circle cx="11" cy="11" r="6.5" /><path d="m20 20-4.2-4.2" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  chats: <><path d="M4 18.5V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H8.5z" /><path d="M8.5 9h7M8.5 12h4" /></>,
  flag: <><path d="M5 21V4" /><path d="M5 4.5h11l-2 4 2 4H5" /></>,
  bell: <><path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z" /><path d="M10 20.5a2 2 0 0 0 4 0" /></>,
  gear: <><path d="m9 3-.5 2a7 7 0 0 0-1.5.9L5 5.3 3 8.7l1.5 1.4a8 8 0 0 0 0 1.8L3 13.3l2 3.4 2-.6a7 7 0 0 0 1.5.9L9 19h4l.5-2a7 7 0 0 0 1.5-.9l2 .6 2-3.4-1.5-1.4a8 8 0 0 0 0-1.8L19 8.7l-2-3.4-2 .6a7 7 0 0 0-1.5-.9L13 3Z" transform="translate(1 1)" /><circle cx="12" cy="12" r="3" /></>,
  back: <path d="M15 5l-7 7 7 7" />,
  chev: <path d="M9 5l7 7-7 7" />,
  down: <path d="M6 9l6 6 6-6" />,
  share: <><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1" /><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1" /></>,
  more: <><circle cx="12" cy="5" r="1.4" /><circle cx="12" cy="12" r="1.4" /><circle cx="12" cy="19" r="1.4" /></>,
  alert: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5v5M12 16h.01" /></>,
  wrench: <><path d="M14.5 6.5a4 4 0 0 0 5 5L12 19a2.1 2.1 0 0 1-3-3l7.5-7.5" /><path d="M14.5 6.5 17 4" /></>,
  eye: <><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" /><circle cx="12" cy="12" r="2.8" /></>,
  check: <path d="M4.5 12.5 9.5 17.5 19.5 7" />,
  checks: <><path d="M2 12.5 6.5 17 15 8" /><path d="M11 16l1 1 8.5-9" /></>,
  x: <path d="M6 6l12 12M18 6 6 18" />,
  mic: <><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" /></>,
  camera: <><path d="M3.5 8.5a2 2 0 0 1 2-2h2l1.5-2h6l1.5 2h2a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" /><circle cx="12" cy="12.5" r="3.5" /></>,
  clip: <path d="M20 11.5 12 19.5a5 5 0 0 1-7-7l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7L9.7 17.2a1.7 1.7 0 0 1-2.4-2.4L15 7" />,
  image: <><rect x="3.5" y="4.5" width="17" height="15" rx="3" /><circle cx="9" cy="10" r="1.8" /><path d="m20.5 16-5-5-9 8.5" /></>,
  video: <><rect x="3" y="6" width="13" height="12" rx="3" /><path d="m16 10.5 5-3v9l-5-3" /></>,
  wave: <path d="M4 10v4M8 7v10M12 4v16M16 8v8M20 11v2" />,
  text: <path d="M5 6.5h14M5 11h14M5 15.5h9" />,
  file: <><path d="M6 3.5h8l4 4v13H6z" /><path d="M14 3.5v4h4" /></>,
  link: <><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1" /><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1" /></>,
  pin: <><path d="M9 4h6l-1 5 3 3v1.5H7V12l3-3z" /><path d="M12 13.5V20" /></>,
  star: <path d="M12 3.8l2.5 5.2 5.6.8-4.05 3.95.95 5.6L12 16.7l-5 2.65.95-5.6L3.9 9.8l5.6-.8z" />,
  place: <><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z" /><circle cx="12" cy="10" r="2.4" /></>,
  at: <><circle cx="12" cy="12" r="3.6" /><path d="M15.6 12v1.4a2.6 2.6 0 0 0 5.2 0V12a8.8 8.8 0 1 0-3.5 7" /></>,
  edit: <><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16z" /><path d="M13.5 6.5l4 4" /></>,
  forward: <><path d="M14 5l6 6-6 6" /><path d="M20 11H10a6 6 0 0 0-6 6v2" /></>,
  smile: <><circle cx="12" cy="12" r="8.5" /><path d="M8.5 14.2a4.2 4.2 0 0 0 7 0" /><path d="M9.2 9.6h.01M14.8 9.6h.01" strokeWidth="2.6" /></>,
  lock: <><rect x="5" y="10.5" width="14" height="10" rx="2.5" /><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" /></>,
  folder: <path d="M3.5 7.5a2 2 0 0 1 2-2h4l2 2.5h7a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" />,
  board: <><rect x="3.5" y="4.5" width="5.5" height="15" rx="1.8" /><rect x="12" y="4.5" width="5.5" height="9.5" rx="1.8" /><path d="M20.5 4.5v15" /></>,
  liste: <><path d="M4 6.5h16M4 12h16M4 17.5h10" /></>,
  panel: <><rect x="3.5" y="4.5" width="17" height="15" rx="2.5" /><path d="M14.5 4.5v15" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" /></>,
  moon: <path d="M19.5 14.5A8 8 0 0 1 9.5 4.5a8 8 0 1 0 10 10z" />,
  cloud: <><path d="M7 18.5a4.5 4.5 0 0 1-.6-9 6 6 0 0 1 11.5 1.6A3.8 3.8 0 0 1 17.5 18.5z" /><path d="m9.5 13.5 2 2 3.5-3.5" /></>,
  cloudOff: <><path d="M7 18.5a4.5 4.5 0 0 1-.6-9 6 6 0 0 1 11.5 1.6A3.8 3.8 0 0 1 17.5 18.5z" /><path d="M4 4l16 16" /></>,
  sparkle: <path d="M12 3.5c.6 4.2 3.3 6.9 7.5 7.5-4.2.6-6.9 3.3-7.5 7.5-.6-4.2-3.3-6.9-7.5-7.5 4.2-.6 6.9-3.3 7.5-7.5z" />,
  send: <path d="M4.5 12 20 4.5 13.5 20l-2.5-6.5z" />,
  reply: <><path d="M9.5 7 4.5 12l5 5" /><path d="M4.5 12H14a5.5 5.5 0 0 1 5.5 5.5V19" /></>,
  logout: <><path d="M14 4.5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4" /><path d="M10 16.5 5.5 12 10 7.5M5.5 12H15" /></>,
  archive: <><rect x="3.5" y="4.5" width="17" height="4" rx="1.5" /><path d="M5 8.5v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9M10 12.5h4" /></>,
  calendar: <><rect x="4" y="5.5" width="16" height="14" rx="3" /><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4" /></>,
  user: <><circle cx="12" cy="8.5" r="3.5" /><path d="M5 20a7 7 0 0 1 14 0" /></>,
  question: <><circle cx="12" cy="12" r="8.5" /><path d="M9.8 9.5a2.3 2.3 0 1 1 3.2 2.1c-.6.3-1 .8-1 1.4v.5M12 16.5h.01" /></>,
  trash: <><path d="M4.5 7h15" /><path d="M9.5 7V4.5h5V7" /><path d="M6.5 7l1 13h9l1-13" /></>,
  reset: <><path d="M4 12a8 8 0 1 0 2.5-5.8" /><path d="M3 4l.5 4.5L8 8" /></>,
  screen: <><rect x="6.5" y="2.5" width="11" height="19" rx="2.8" /><circle cx="12" cy="11.5" r="2.6" /><path d="M10.5 18.5h3" /></>,
  inbox: <><path d="M4 13.5 6.2 6a2 2 0 0 1 1.9-1.5h7.8A2 2 0 0 1 17.8 6L20 13.5V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" /><path d="M4 13.5h4.5l1.5 2.5h4l1.5-2.5H20" /></>,
  key: <><circle cx="8" cy="15" r="3.5" /><path d="m10.5 12.5 8-8M16 7l2.5 2.5M14 9l2 2" /></>,
} as const;

const filled = {
  starFill: <path d="M12 3.8l2.5 5.2 5.6.8-4.05 3.95.95 5.6L12 16.7l-5 2.65.95-5.6L3.9 9.8l5.6-.8z" />,
  play: <path d="M8 5v14l11-7z" />,
  pause: <><rect x="6.5" y="5" width="4" height="14" rx="1.2" /><rect x="13.5" y="5" width="4" height="14" rx="1.2" /></>,
  stop: <rect x="6" y="6" width="12" height="12" rx="2.5" />,
  apple: <path d="M16.4 12.8c.03 2.9 2.55 3.86 2.58 3.87-.02.07-.4 1.4-1.35 2.77-.81 1.19-1.66 2.36-3 2.39-1.31.02-1.74-.78-3.24-.78s-1.97.76-3.22.8c-1.28.05-2.26-1.28-3.09-2.46-1.7-2.42-2.97-6.97-1.26-10.05.85-1.53 2.37-2.5 4.02-2.53 1.27-.02 2.46.86 3.24.86.77 0 2.23-1.06 3.76-.9.64.03 2.43.23 3.58 1.75-.1.06-2.14 1.25-2.03 3.28M13.9 4.5c.68-.83 1.14-1.98.01-3.13-1 .04-2.2.67-2.9 1.5-.63.74-1.19 1.92-.98 3.05 1.12.09 2.19-.58 2.87-1.42" />,
} as const;

export type IconName = keyof typeof paths | keyof typeof filled;

export function Icon({ name, size = 22, ...rest }: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  const isFilled = name in filled;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={isFilled ? 'currentColor' : 'none'}
      stroke={isFilled ? 'none' : 'currentColor'}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {isFilled ? filled[name as keyof typeof filled] : paths[name as keyof typeof paths]}
    </svg>
  );
}
